import { Navigate, Route, Routes } from 'react-router';
import { LoadingRegion } from '@gatecheckpro/design-system';
import { useSession } from './lib/session.tsx';
import { DiscoverPage } from './pages/DiscoverPage.tsx';
import { EventPage } from './pages/EventPage.tsx';
import { SeatSelectionPage } from './pages/SeatSelectionPage.tsx';
import { CabsCallbackPage } from './pages/CabsCallbackPage.tsx';
import { CabsFirstUsePage } from './pages/CabsFirstUsePage.tsx';
import { SignInPage } from './pages/SignInPage.tsx';
import { RegisterPage } from './pages/RegisterPage.tsx';
import { MyTicketsPage } from './pages/MyTicketsPage.tsx';
import { AccountPage } from './pages/AccountPage.tsx';
import { OrderPage } from './pages/OrderPage.tsx';
import { OrdersPage } from './pages/OrdersPage.tsx';
import { PassPage } from './pages/PassPage.tsx';
import { PaymentReturnPage } from './pages/PaymentReturnPage.tsx';

export function App() {
  const { state } = useSession();

  if (state.status === 'loading') {
    return (
      <main className="gc-auth">
        <div className="gc-auth__card">
          <LoadingRegion label="Opening GateCheck" />
        </div>
      </main>
    );
  }

  return (
    <Routes>
      {/* Discovery is public. It is also honest that there is nothing to discover yet. */}
      <Route path="/" element={<DiscoverPage />} />
      {/* Public. An unpublished slug answers exactly as one that never existed. */}
      <Route path="/e/:slug" element={<EventPage />} />
      {/*
        Public, deliberately. Somebody deciding whether to come should be able
        to see the room and what the seats cost without an account; holding a
        chair is what needs one, and the page asks then.
      */}
      <Route path="/e/:slug/sessions/:sessionId/seats" element={<SeatSelectionPage />} />
      <Route path="/sign-in" element={<SignInPage />} />
      {/*
        Where CABS Identity returns the browser. Public, because the person is
        not signed in yet — that is what this page is completing.
      */}
      <Route path="/auth/cabs/callback" element={<CabsCallbackPage />} />
      {/*
        Where a CABS identity with no GateCheck account starts. Public for the
        same reason as the callback: this is what creates the account.
      */}
      <Route path="/auth/cabs/first-use" element={<CabsFirstUsePage />} />
      <Route path="/register" element={<RegisterPage />} />
      {state.status === 'authenticated' ? (
        <>
          <Route path="/tickets" element={<MyTicketsPage />} />
          <Route path="/tickets/:ticketId" element={<PassPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/orders/:orderId" element={<OrderPage />} />
          {/*
            Where the payment provider returns the customer. Reads nothing from
            the URL: arriving here proves nothing, so the page asks the server.
          */}
          <Route path="/orders/:orderId/return" element={<PaymentReturnPage />} />
          <Route path="/account" element={<AccountPage />} />
        </>
      ) : (
        <>
          <Route path="/tickets" element={<Navigate to="/sign-in" replace />} />
          <Route path="/tickets/:ticketId" element={<Navigate to="/sign-in" replace />} />
          <Route path="/orders" element={<Navigate to="/sign-in" replace />} />
          <Route path="/orders/:orderId" element={<Navigate to="/sign-in" replace />} />
          <Route path="/orders/:orderId/return" element={<Navigate to="/sign-in" replace />} />
          <Route path="/account" element={<Navigate to="/sign-in" replace />} />
        </>
      )}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
